import { AfterViewInit, Component, Inject, Input, LOCALE_ID, OnInit, SimpleChanges } from '@angular/core';
import { Router, ResolveEnd } from '@angular/router';

import { environment } from 'environments/environment';

import { AuthService } from '@shared/modules/auth/services/auth.service';
import { TelemetryService } from '@shared/services/telemetry.service';

@Component({
  selector: 'cr-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss'],
  standalone: false
})
export class PageHeaderComponent implements OnInit {

  environmentName: string;
  errorReadingUpcomingLesson = '';
  imagesServer: string;
  homeUrl: string;
  isLocaleEn = true;
  isReadingUpcomingLesson = true;
  upcomingLesson: any = null;
  urlRoot = environment.urlRoot;

  constructor(
    @Inject(LOCALE_ID) private locale: string,
    private authService: AuthService,
    private router: Router,
    private telemetryService: TelemetryService
  ) {

    // Set telemetry once the router has resolved the final route
    this.router.events.subscribe((routerData) => {
      if (routerData instanceof ResolveEnd) {
        this.setTelemetry(routerData.url);
      }
    });
  }

  ngOnInit() {

    // Set environment name if defined
    if (environment.name) {
      this.environmentName = environment.name.toUpperCase();
    }

    // Set images server
    this.imagesServer = environment.imagesServer;

    // Set home URL
    this.homeUrl = environment.urlRoot;

    // Check locale
    this.isLocaleEn = !this.locale || (this.locale.substring(0, 2) === 'en');
  }

  private setTelemetry(sourcePath: string) {
    this.telemetryService.inject('CLICK', 'announcement-bar-left-link', sourcePath, true);
    this.telemetryService.inject('CLICK', 'announcement-bar-right-link', sourcePath, true);
    this.telemetryService.inject('CLICK', 'cwk-logo', sourcePath, true);
  }
}
